import axios from "axios";
import Swal from "sweetalert2";
import {
  CAMPAIGN_VIEW_REQUEST,
  CAMPAIGN_VIEW_FAIL,
  CAMPAIGN_VIEW_SUCCESS,
  LANG_VIEW_REQUEST,
  LANG_VIEW_SUCCESS,
  ADMIN_VIEW_REQUEST,
  ADMIN_VIEW_FAIL,
  ADMIN_VIEW_SUCCESS,
  TRANSACTION_VIEW_SUCCESS,
  TRANSACTION_VIEW_FAIL,
  TRANSACTION_VIEW_REQUEST,
} from "../constants/campaignConstants";

export const getCampaignView = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: CAMPAIGN_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/get-campaigndetailsby-id",
      { campaign_id: id.campaignId, is_deleted: 0 },
      config
    );
    dispatch({ type: CAMPAIGN_VIEW_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CAMPAIGN_VIEW_FAIL,
      payload:
        error?.response?.data?.message
          ? error.response.data.message
          : error.message,
    });
    Swal.fire({
      title: error?.response?.data?.message || "An error occurred",
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
  }
};

export const getLanguageDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: LANG_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "languages-text-by-id",
      { id: id.langId },
      config
    );
    dispatch({ type: LANG_VIEW_SUCCESS, payload: data });
  } catch (error) {
    Swal.fire({
      title: error?.response?.data?.message || "An error occurred",
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
  }
};

export const getAdminDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "admin/get-user-profile-details",
      { user_id: id },
      config
    );
    dispatch({ type: ADMIN_VIEW_SUCCESS, payload: data });
  } catch (error) {
    Swal.fire({
      title: error?.response?.data?.message || "An error occurred",
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: ADMIN_VIEW_FAIL,
      payload:
        error?.response?.data?.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getTransactionDetails = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: TRANSACTION_VIEW_REQUEST });
    const config = {
      headers: {
        "x-access-token": token,
      },
    };
    const { data } = await axios.post(
      process.env.REACT_APP_API + "get-trasactionetailsbyid",
      { id: id.transactionId },
      config
    );
    dispatch({ type: TRANSACTION_VIEW_SUCCESS, payload: data });
  } catch (error) {
    Swal.fire({
      title: error?.response?.data?.message || "An error occurred",
      timerProgressBar: true,
      icon: "error",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    dispatch({
      type: TRANSACTION_VIEW_FAIL,
      payload:
        error?.response?.data?.message
          ? error.response.data.message
          : error.message,
    });
  }
};
